(function (mod) {
    if (typeof exports == "object" && typeof module == "object") // CommonJS
        mod(require("codemirror"));
    else if (typeof define == "function" && define.amd) // AMD
        define(["../../../../node_modules/codemirror/lib/codemirror"], mod);
    else // Plain browser env
        mod(CodeMirror);
})(function (CodeMirror) {
    "use strict";
    var GUTT_CLASS_CHANGED_LINE = "CodeMirror_gutter_changed-line";
    var GUTT_CLASS_DELETED_LINE = "CodeMirror_gutter_deleted-line";
    var GUTT_CLASS_ADDED_LINE = "CodeMirror_gutter_added-line";
    var GUTTER = "gutter";

    CodeMirror.defineOption("highlightChangedLines", false, function (cm, val, old) {
        var prev = old == CodeMirror.Init ? false : old;

        if (val == prev) return;

        if (prev) {
            cm.off("saveContent", onSaveContent);
            cm.off("highlightChanges", onHigHlightChanges);
            clearAllLines(cm);
            delete cm.state.addedLines;
            delete cm.state.changedLines;
            delete cm.state.deletedLines;
        }
        if (val) {
            cm.state.addedLines = [];
            cm.state.changedLines = [];
            cm.state.deletedLines = [];
            cm.state.savedText = '';
            cm.on("highlightChanges", onHigHlightChanges);
            cm.on("saveContent", onSaveContent);
        }
    });

    function markUnsavedLines(cm, added, changed, deleted) {
        for (let i = 0; i < added.length; i++) {
            cm.addLineClass(added[i], GUTTER, GUTT_CLASS_ADDED_LINE);
        }
        for (let i = 0; i < changed.length; i++) {
            cm.addLineClass(changed[i], GUTTER, GUTT_CLASS_CHANGED_LINE);
        }
        for (let i = 0; i < deleted.length; i++) {
            cm.addLineClass(deleted[i], GUTTER, GUTT_CLASS_DELETED_LINE);
        }
        cm.state.addedLines = added;
        cm.state.changedLines = changed;
        cm.state.deletedLines = deleted;
    }

    function clearAllLines(cm) {
        cm.operation(() => {
            cm.eachLine((line) => {
                cm.removeLineClass(line, GUTTER, GUTT_CLASS_ADDED_LINE);
                cm.removeLineClass(line, GUTTER, GUTT_CLASS_DELETED_LINE);
                cm.removeLineClass(line, GUTTER, GUTT_CLASS_CHANGED_LINE);
            });
        });
    }

    function convertToCodeMirrorLine(lines) {
        return lines.map(el => el - 1);
    }

    function removeCloseLines(lines) {
        var notCloseLines = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];

            if (i > 0) {
                if (line - lines[i - 1] > 1) {
                    notCloseLines.push(line);
                }
            } else {
                notCloseLines.push(line);
            }
        }
        return notCloseLines;
    }

    function onHigHlightChanges(cm, linesInfo) {
        cm.operation(() => {
            clearAllLines(cm);
            markUnsavedLines(
                cm,
                convertToCodeMirrorLine(linesInfo.added),
                convertToCodeMirrorLine(linesInfo.changed),
                convertToCodeMirrorLine(removeCloseLines(linesInfo.deleted))
            );
        });
    }

    function onSaveContent(cm, value) {
        clearAllLines(cm);
        cm.state.savedText = value;
        cm.state.addedLines = [];
        cm.state.changedLines = [];
        cm.state.deletedLines = [];
    }
});
